export default "__VITE_ASSET__9ac5ddb6__"